import React from "react";
import PropTypes from 'prop-types';
import { ColorPicker, Dropdown } from '@wordpress/components';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

import './style.scss';

class ColorInput extends Base {
	input() {
		const { inputValue } = this.props;
		
		return(
			<Dropdown
				renderToggle={ ( { isOpen, onToggle } ) => (
					<div className="ok-color-input-btn" tabIndex={ 0 } onKeyDown={ ( e ) => {
						if ( e.keyCode === 13 || e.keyCode === 32 ) {
							onToggle();
						}
					} } style={ {
						backgroundColor: inputValue,
					} } onClick={ onToggle } aria-expanded={ isOpen } />
				) }
				renderContent={ () => (
					<ColorPicker color={ inputValue } onChangeComplete={ ( newValue ) => {
						if ( newValue.rgb.a === 1 ) {
							this.onChange( newValue.hex );
						} else {
							this.onChange( `rgba(${newValue.rgb.r}, ${newValue.rgb.g}, ${newValue.rgb.b}, ${newValue.rgb.a})` );
						}
					} } />
				) }
			/>
			
		);
	}
}


ColorInput.propTypes = {
	inputValue: PropTypes.string,
};

export default withInput( ColorInput );
